export default function Testimonials() {
  return (
    <section className="py-20 bg-white" id="testimonials">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="font-display text-3xl gold-gradient-text mb-6">
          Voices of Excellence
        </h2>

        <p className="text-xl italic mb-8 text-slate-600">
          "The discipline and musicality brought by the Royal Bagpipe Band & Academy
          ensemble changed the entire atmosphere of our annual convocation."
        </p>

        <h4 className="font-bold text-slate-900 mb-2">
          Dr. Rajesh Khanna
        </h4>
        <p className="text-sm text-slate-500">
          Principal, Heritage International School
        </p>
      </div>
    </section>
  );
}